import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";

const StyledLink = styled(Link)({
  marginRight: "50px",
  display: "flex",
  alignItems: "center",
  transition: "transform 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
  },
});

const HeaderBrandLogo = ({
  to,
  logo,
  linkClassName,
  imageClassName,
  linkProps,
  imageProps,
  ...otherProps
}) => (
  <StyledLink
    aria-label="Logo"
    to={to}
    className={linkClassName}
    {...linkProps}
    {...otherProps}
  >
    <img src={logo} alt="logo" className={imageClassName} {...imageProps} />
  </StyledLink>
);

HeaderBrandLogo.displayName = "HeaderBrandLogo";

HeaderBrandLogo.propTypes = {
  to: PropTypes.string.isRequired,
  logo: PropTypes.node.isRequired,
  linkClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  linkProps: PropTypes.object,
  imageProps: PropTypes.object,

  // The following props are only used by the "Header" component
  showWhenCollapsed: PropTypes.bool,
  showOnlyInDrawer: PropTypes.bool,
  showOnlyInHeader: PropTypes.bool,
  right: PropTypes.bool,
};

export default HeaderBrandLogo;